import React from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'components/Form';

import styles from './styles.css';

type FileUploaderParams = {
  accept: string;
  multiple?: boolean;
  onChange: (files: File[]) => void;
  label: string;
  isLoading?: boolean;
};

const FileUploader: React.FC<FileUploaderParams> = ({
  onChange,
  accept,
  multiple,
  label,
  isLoading,
}) => (
  <Dropzone accept={accept} multiple={!!multiple} onDrop={onChange}>
    {({ getRootProps, getInputProps }) => (
      <section>
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <Button isLoading={isLoading}>{label}</Button>
        </div>
      </section>
    )}
  </Dropzone>
);

export default FileUploader;
